// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IContactInfoDto } from './IContactInfoDto';
import {
    IContactInfoDtoFromJSON,
    IContactInfoDtoFromJSONTyped,
    IContactInfoDtoToJSON,
    IContactInfoDtoToJSONTyped,
} from './IContactInfoDto';

/**
 * 
 * @export
 * @interface ICustomPageContactInfoDto
 */
export interface ICustomPageContactInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContactInfoDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContactInfoDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageContactInfoDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageContactInfoDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageContactInfoDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IContactInfoDto>}
     * @memberof ICustomPageContactInfoDto
     */
    content?: Array<IContactInfoDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageContactInfoDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContactInfoDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContactInfoDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContactInfoDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageContactInfoDto interface.
 */
export function instanceOfICustomPageContactInfoDto(value: object): value is ICustomPageContactInfoDto {
    return true;
}

export function ICustomPageContactInfoDtoFromJSON(json: any): ICustomPageContactInfoDto {
    return ICustomPageContactInfoDtoFromJSONTyped(json, false);
}

export function ICustomPageContactInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageContactInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IContactInfoDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageContactInfoDtoToJSON(json: any): ICustomPageContactInfoDto {
    return ICustomPageContactInfoDtoToJSONTyped(json, false);
}

export function ICustomPageContactInfoDtoToJSONTyped(value?: ICustomPageContactInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IContactInfoDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

